import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';
import classNames from 'classnames';

import { CheckChunky } from '@eb/eds-iconography';

import NotificationScreen from '../NotificationScreen';

import './PasswordlessEmailStatus.scss';

const PasswordlessEmailStatus = ({ email }) => {
    const componentClasses = classNames(
        'eds-l-mar-vert-14 passwordless-email-status',
    );
    const iconProps = {
        iconColor: 'ui-700',
        iconType: <CheckChunky />,
    };
    const headerText = gettext('Check your email');
    let subtitleText = gettext(
        'We sent your login link to your email address.',
    );

    //Need to conditionally check if the email is present and update copy accordingly
    //in case the user refreshes the notification page and we lose the email from state.
    if (email) {
        subtitleText = gettext('We sent your login link to %(email)s', {
            email,
        });
    }

    return (
        <div className={componentClasses}>
            <NotificationScreen
                {...iconProps}
                headerText={headerText}
                subtitleText={subtitleText}
            />

            <p className="eds-text--center eds-text-color--grey-600 eds-text-bm eds-l-mar-hor-3">
                {gettext('For your security, the link expires in 2 hours')}
            </p>
        </div>
    );
};

PasswordlessEmailStatus.propTypes = {
    email: PropTypes.string,
};

export default PasswordlessEmailStatus;
